function getVariation(placement) {
  return placement.split('-')[1];
}

export { getVariation as g };
//# sourceMappingURL=getVariation-8185e5d3.js.map
